module.exports = __webpack_public_path__ + "static/media/galerija_2019 (7).82b13756.jpg";